import { DataTable, MainButton, PageWrapper, STATUSPAGE } from '@repo/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'reactstrap';

import { makeColumnsTask } from '../common/columns-task';
import { ModalNewTask } from '../components/modalNewTask';
import { useTask } from '../hooks/useTask';

export const Task = () => {
  //State

  const {
    taskId,
    taskList,
    isModalOpen,
    taskByIdSelected,
    requestTaskDelete,
    requestTaskUpdate,
    requestTaskCreate,
    handleToggleModal,
    requestTaskGetById,
    setTaskByIdSelected,
    validationFormTask,
    loadingTaskById,
    loadingCreateOrEditTask,
    listStatus,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearchRemote,
    handleSortRemote,
  } = useTask();

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhuma tarefa encontrada',
    noDataDescription: 'Não há tarefas cadastradas no momento.',
  };

  const navigate = useNavigate();

  const clearNavigationState = () => {
    navigate(null, { state: null });
  };

  const handleEditTask = (courseId: string) => {
    handleToggleModal();
    requestTaskGetById({ id: courseId });
    navigate(null, {
      state: { id: courseId, name: courseId },
    });
  };

  const handleDeleteTask = (courseId: string) => {
    requestTaskDelete({ id: courseId });
  };

  useEffect(() => {
    clearNavigationState();
  }, []);

  return (
    <PageWrapper title="Tarefas">
      <ModalNewTask
        clearNavigationState={clearNavigationState}
        taskId={taskId}
        isOpen={isModalOpen}
        toggleModal={handleToggleModal}
        taskByIdSelected={taskByIdSelected}
        requestTaskUpdate={requestTaskUpdate}
        requestTaskCreate={requestTaskCreate}
        validationFormTask={validationFormTask}
        setTaskByIdSelected={setTaskByIdSelected}
        loadingTaskById={loadingTaskById}
        loadingCreateOrEditTask={loadingCreateOrEditTask}
      />

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Tarefas</h4>
          <p className="text-muted mb-0">
            Cadastre aqui as tarefas que podem ser realizadas pelos estagiários.
          </p>
        </div>

        <MainButton
          onClick={() => {
            handleToggleModal();
            clearNavigationState();
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Nova Tarefa
        </MainButton>
      </div>

      <Card className="p-3">
        <DataTable
          noDataTitle={noDataConfig.noDataTitle}
          noDataDescription={noDataConfig.noDataDescription}
          actions={[
            {
              id: 1,
              name: 'Editar',
              label: 'Editar',
              onPress: (course) => handleEditTask(course.id),
              nameFeatherIcon: 'edit',
              classNameColorIcon: 'primary',
            },
          ]}
          data={taskList.data ?? []}
          pagination
          paginationServer
          loading={listStatus === STATUSPAGE.LOADING}
          columns={makeColumnsTask()}
          handleDelete={(id) => handleDeleteTask(id)}
          keysSearch={['name']}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          sortServer
          canSearch
          searchServer
          onSearch={handleSearchRemote}
          onSort={handleSortRemote}
          paginationTotalRows={taskList.total ?? 0}
          defaultSortAsc={true}
          defaultSortFieldId={1}
        />
      </Card>
    </PageWrapper>
  );
};
